export const sleep = async (ms: number = 2000) => {
  return await new Promise((r) => setTimeout(r, ms));
};
